const translations = {
    chooseEntity: 'Choose {{entityType}}',
    chooseMultiple: 'Choose multiple',
    noItemsFound: 'No items found'
};

export default translations;
